import { useMutation } from '@tanstack/react-query';

import { $api, errorHandler } from 'modules/global';

export const useSaveTest = () =>
  useMutation({
    mutationFn: async ({ id, status }: { id?: number; status: boolean }) => {
      const { data } = await $api.post('/subject', { id, status });

      return data;
    },
    onError: errorHandler()
  });
